var React = require('react');

function MobilePrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.99599e-06 7.75466L7.24536 15L7.85866 14.3867L1.66031 8.18836L70 8.18836L70 7.32102L1.66025 7.32102L7.85866 1.12261L7.24536 0.509309L6.99599e-06 7.75466Z","fill":"#202020"}));
}

MobilePrev.defaultProps = {"width":"70","height":"15","viewBox":"0 0 70 15","fill":"none"};

module.exports = MobilePrev;

MobilePrev.default = MobilePrev;
